// APIs for interacting with the client
import { PluginApiAdapter } from "./PluginApiAdapter";
import GoogleAnalyticsApis from './GoogleAnalytics.api'
import JaegerApi from './Jaeger.api'
import BaseUrlApis from "./axios/base.api";
const jaegerApi = new JaegerApi()
const googleAnalyticsApis = new GoogleAnalyticsApis();

const PluginJS = new PluginApiAdapter();
const baseUrlApis = new BaseUrlApis();

export {
  PluginJS,
  jaegerApi,
  googleAnalyticsApis,
  baseUrlApis
}